import type { Node } from '@tiptap/pm/model'
import type { EditorState } from '@tiptap/pm/state'

export type Alignment = 'left' | 'center' | 'right' | 'justify'

export function getActiveTextAlign(state: EditorState): Alignment | undefined
export function getActiveTextAlign(
  state: EditorState,
  defaultAlignment: Alignment
): Alignment
export function getActiveTextAlign(
  state: EditorState,
  defaultAlignment?: Alignment
): Alignment | undefined {
  const { from, to } = state.selection
  const nodes: Node[] = []

  state.doc.nodesBetween(from, to, (node) => {
    if (node.isText) {
      return
    }

    nodes.push(node)
  })

  const matchedNode = nodes.find((node) => node.attrs.textAlign !== undefined)
  return matchedNode?.attrs.textAlign ?? defaultAlignment
}
